<div breadcrumbs [option]='breadcrumbOptions'>
</div>

<!-- @if ('{{!(getProgramName$ | async)}}';refreshBlock) {
  <h1 prog-head>{{(program$ | async)?.name}}</h1>
} -->

<h1 prog-head *ngIf="!(getProgramName$ | async); else refreshBlock">{{(program$ | async)?.name}}</h1>
<ng-template #refreshBlock>
  <div class="prog-head-name"> {{getProgramName$ | async}}</div>
</ng-template>

<div [@.disabled]="true">
  <mat-tab-group [(selectedIndex)]="setTabActive" (selectedTabChange)="navigateToTab($event)">
    @if (isAdminRole) {
    <mat-tab label="Program Overview">
      <program-overview (sessionCount)=sessionCountReceived($event)
        [parentSpinner]="showGlobalSpinnerParent"></program-overview>
    </mat-tab>
    }
    @if (isAdminRole) {
    <mat-tab label="Classes">
      <program-classes [parentSpinner]="showGlobalSpinnerParent"></program-classes>
    </mat-tab>
    }
    @if (isAdminRole) {
    <mat-tab label="Sessions">
      <program-sessions (isCancelBannerOpen)="getCancelBannerStatus($event)" [parentSpinner]="showGlobalSpinnerParent"
        [sessionCount]="sessionCount"></program-sessions>
    </mat-tab>
    }
    @if (isAdminRole) {
    <mat-tab label="Registration Status">
      <program-registration [parentSpinner]="showGlobalSpinnerParent"></program-registration>
    </mat-tab>
    }
    @if (isAdminRole) {
    <mat-tab label="Program Documents">
      <app-program-documents (isProgramDocOpen)="getProgramDocFormStatus($event)"
        [parentSpinner]="showGlobalSpinnerParent"></app-program-documents>
    </mat-tab>
    }
    @if (!isAdminRole) {
    <mat-tab label="Classes">
      <program-classes></program-classes>
    </mat-tab>
    }
  </mat-tab-group>
</div>